import { render, staticRenderFns } from "./TicketConnection.vue?vue&type=template&id=308a963f&scoped=true"
import script from "./TicketConnection.vue?vue&type=script&lang=js"
export * from "./TicketConnection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308a963f",
  null
  
)

export default component.exports